<script>

export default {
  name: 'VolanCard',
  props: {
    name: {
      type: String,
    },
    value: {
      type: Number,
    },
    total: {
      type: Number,
    },
    route: {
      required: false,
      type: [String,Object],
      default: () => null,
    },
    format: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
  },
  data(vm) {
    return {};
  },
  methods: {
    goTo() {
      if (typeof this.route === 'string' && this.route) {
        const routeData = this.$router.resolve({ name: this.route });
        window.open(routeData.href, '_blank');
      }
      if (this.route?.to || this.route?.name) {
        const routeData = this.$router.resolve(this.route);
        window.open(routeData.href, '_blank');
      }
    }
  }
};
</script>

<template>
  <VCard
    outlined
    class="card"
  >
    <VListItem v-if="!loading" three-line>
      <VListItemContent>
        <div class="text-overline mb-2">
          {{ name }}
        </div>
        <div class="divValue">
          <div class="value">
            {{ $n(value || 0, format) }}
          </div>
          <div v-if="total && value" class="percent">
            {{ ((value*100)/total).toFixed(0) }}%
          </div>
          <div class="icon">
            <VIcon v-if="route" @click="goTo">
              mdi-open-in-new
            </VIcon>
          </div>
        </div>
      </VListItemContent>
    </VListItem>
    <div v-else class="my-6 mx-4">
      <VProgressCircular indeterminate color="volanGreenDarkBoth" />
    </div>
  </VCard>
</template>

<style scoped lang="scss">
.card{
  margin: 8px;
  border: 0.5px solid var(--v-volanGreenDarkBoth-base);
  width: 100%;
  .divValue{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding: 1px 6px 1px 14px;

    .value {
      font-size: 36px;
      color: #d8dfd7;
    }
    .percent {
      font-size: 24px;
      color: #d8dfd7;
    }

    .icon{
      cursor: pointer;
      :deep .v-icon {
        color: #d8dfd7;
      }
    }
  }
}


</style>
